import React from 'react'
import clsx from 'clsx'
import { AccordionDetails } from '@mui/material'

import NewCount from '../BaseConversation/NewCount'
import SelectedRectangle from '../../atoms/SelectedItemRectangle'
import OverflowText from '../../atoms/OverflowText'

import useStyles, { StyledAccordion, StyledSummary } from './styles'

interface AccordionV2Props {
  title: string
  selected?: boolean
  count?: number
  onClick?: () => void
  children: React.ReactNode
  className?: string
  forceExpand?: boolean
}

const AccordionV2: React.FC<AccordionV2Props> = ({
  title,
  selected,
  count,
  onClick,
  children,
  className,
  forceExpand = false
}) => {
  const [expanded, setExpanded] = React.useState(forceExpand)

  const toggleOpen = e => {
    setExpanded(!expanded)
    e.stopPropagation()
  }

  React.useEffect(() => {
    if (selected && !expanded) {
      setExpanded(true)
    }
    //eslint-disable-next-line
  }, [selected])

  const classes = useStyles()

  return (
    <StyledAccordion expanded={expanded} elevation={0} className={className}>
      <div className={classes.summaryContainer}>
        <StyledSummary
          expanded={expanded}
          onClick={e => {
            onClick && onClick()
            e.stopPropagation()
          }}
          IconButtonProps={{
            onClick: toggleOpen
          }}
        >
          <div
            className={clsx(classes.header, selected ? classes.selected : null)}
          >
            {selected && <SelectedRectangle />}

            <OverflowText>
              <label>{title}</label>
            </OverflowText>
          </div>
        </StyledSummary>
        {count > 0 && <NewCount count={count} dontGroup />}
      </div>

      <AccordionDetails style={{ padding: '0px 0px 0px 36px' }}>
        <div className={classes.content}>{children}</div>
      </AccordionDetails>
    </StyledAccordion>
  )
}

export default AccordionV2
